<template>
  <div class="card-curvey">
    <h2>Campaigns (Last 30 Campaigns)</h2>

    <apex-chart
      type="bar"
      :height="400"
      :options="options"
      :series="series"
    ></apex-chart>
  </div>
</template>

<script>
import apexChart from "vue-apexcharts";

export default {
  name: "campaignsBarChart",
  components: {
    apexChart,
  },
  props: {
    overallData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      options: {
        colors: [
          this.$vuetify.theme.warning,
          "grey",
          "#2196f3",
          this.$vuetify.theme.secondary,
          "#ff5252",
        ],
        plotOptions: {
          bar: {
            borderRadius: 8,
            horizontal: false,
          },
        },
        chart: {},
        fill: {
          opacity: 1,
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            formatter(value) {
              return value + "$";
            },
          },
        },
      },
      series: [],
    };
  },

  watch: {
    overallData: {
      handler(newVal) {
        this.getChartsData(newVal);
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    getChartsData(data) {
      if (!data || !data.campaignsAnalytics) {
        this.series = [];
        this.options = {
          ...this.options,
          xaxis: {
            ...this.options.xaxis,
            categories: [],
          },
        };
        return;
      }

      let campaigns = data.campaignsAnalytics || [];

      // Render only 30 campaigns (but keep original data intact)
      if (campaigns.length > 30) {
        campaigns = campaigns.slice(0, 30);
      }

      // x-axis categories = campaign names
      const categories = campaigns.map((c) => c.name);

      const series = [];
      if (campaigns[0] && campaigns[0].msg_status) {
        for (let i = 0; i < campaigns[0].msg_status.length; i++) {
          const label = campaigns[0].msg_status[i].label;
          const serie = {
            name: label,
            data: [],
          };

          for (let j = 0; j < campaigns.length; j++) {
            const count = campaigns[j].msg_status[i]
              ? campaigns[j].msg_status[i].count
              : 0;
            serie.data.push(count);
          }

          series.push(serie);
        }
      }

      this.series = series;

      // 🔹 overwrite options like your original code, but keep colors/fill
      this.options = {
        ...this.options,
        legend: {
          position: "top",
        },
        chart: {
          ...this.options.chart,
          type: "bar",
          height: 400, // same as original
          stacked: true,
          toolbar: {
            show: true,
            export: {
              csv: {
                filename: undefined,
                headerCategory: "Category",
              },
            },
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            horizontal: false,
          },
        },
        xaxis: {
          categories,
        },
        yaxis: {
          labels: {
            formatter(value) {
              return Math.trunc(value);
            },
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.card-curvey {
  /* keep it simple so height is controlled mostly by the chart */
  height: auto;
}
</style>
